import { useEffect, useReducer, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useTemplatesContext } from "../../context/templatesContext";

export const useSearchParamsToReducer = ({
	searchData,
}: {
	searchData: Function;
}) => {
	const [shouldSearch, refetch] = useReducer((x) => x + 1, 0);
	const [searchParams, setSearchParams] = useSearchParams();
	const isMountRef = useRef(true);

	const {
		state: { firstTime, searchAssetIdToTable, searchText },
		actions,
	} = useTemplatesContext();

	useEffect(() => {
		let shouldUpdate = false;
		let triggerSearch = false;

		if (searchParams.has("search")) {
			const search = searchParams.get("search");
			if (search === "") {
				searchParams.delete("search");
				shouldUpdate = true;
			} else if (search !== searchText) {
				// Only trigger if value actually changed
				actions.setSearchText(search);
				triggerSearch = true;
			}
		} else if (searchText !== "") {
			// Only trigger if clearing non-empty search
			actions.setSearchText("");
			triggerSearch = true;
		}

		if (shouldUpdate) {
			setSearchParams(searchParams, { replace: true });
		}

		// Trigger search when parameters change
		if (triggerSearch || firstTime) {
			refetch();
			if (firstTime) {
				actions.setFirstTime(false);
			}
		}
	}, [searchParams]);

	useEffect(() => {
		if (!isMountRef.current && searchAssetIdToTable !== 0) {
			searchData();
		}
		isMountRef.current = false;
	}, [shouldSearch, searchAssetIdToTable]);
};
